import React from 'react';
import Section from '../../../elements/Section';
import Title from '../../../elements/Title';
import Link from '../../../components/Link';
import List, { ListItem } from '../../../elements/List';
import { LINKS, PUBLICATIONS } from '../utils';

export default function OtherInformation() {
  return (
    <Section>
      <Title>Other Information</Title>
      <List>
        <ListItem>
          <Link href={LINKS.registerExtract} target="_blank">
            Extract Belgian Legal Entities Register as of February 27th, 2018
            (in Dutch)
          </Link>
        </ListItem>
        <List sublist>
          <ListItem>
            <Link href={LINKS.registerSource} target="_blank">
              Source
            </Link>
          </ListItem>
        </List>
        <ListItem>
          Publications in the Belgian Gazette (
          <Link href={LINKS.gazetteSource} target="_blank">
            source
          </Link>
          )
        </ListItem>
        <List sublist>
          {PUBLICATIONS.map((item, i) => (
            <ListItem key={i}>
              <Link href={item.href} target="_blank">
                {item.name}
              </Link>
            </ListItem>
          ))}
        </List>
      </List>
    </Section>
  );
}
